import Vue from 'vue'
import Router from 'vue-router'
import Logout from '@/components/Login/Logout.vue'
import Dashboard from '@/components/Dashboard.vue'
import Login from '@/components/Login/Login.vue'
import Module from '@/components/module/Module.vue'
import Peergroup from '@/components/module/Peergroup.vue'
import PeergroupOverview from '@/components/module/PeergroupOverview.vue'
import StructureData from '@/components/module/StructureData.vue'
import Suche from '@/components/module/Suche.vue'
import Newsbox from '@/components/module/Newsbox.vue'
import ModuleConfig from '@/components/module/Config.vue'
import DashItem from '@/components/DashItem.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import ResetPasswordExpires from '@/components/ResetPasswordExpires.vue'
import Administration from '@/components/admin/Administration.vue'
import NewsboxGlobal from '@/components/Newsbox.vue'
import TableSearchMaskColumns from '@/components/tables/TableSearchMaskColumns.vue'
import TLConfig from '@/components/tables/TableHitListColumns.vue'
import AdminLog from '@/components/admin/AdminLog'
import Register from '@/components/Register'
import Forward from '@/components/Forward'
import PasswordContact from '@/components/PasswordContact'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  beforeEnter: (to, from, next) => {
    const { uri } = to.query
    if (uri != null && uri !== '/') {
      next(false)
      this.$router.push(uri)
    } else {
      next()
    }
  },
  hashbang: false,
  history: true,
  linkActiveClass: 'active-class',
  routes: [
    {
      path: '/',
      name: 'LoginGeneral',
      component: Login
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/PasswordContact',
      name: 'PasswordContact',
      component: PasswordContact
    },
    {
      path: '/di',
      name: 'DashItem',
      component: DashItem,
      children: [
        {
          path: 'Peergroup/:idModule',
          name: 'Peergroup',
          component: Peergroup
        },
        {
          path: 'Peergroup/:idModule/:aaNr/:crefoNr/:rkNr/:source/:year',
          name: 'PeergroupWithAnchor',
          component: Peergroup
        },
        {
          path: 'Peergroup/:idModule/overview',
          name: 'PeergroupOverview',
          component: PeergroupOverview
        },
        {
          path: 'Administration',
          name: 'Administration',
          component: Administration
        },
        {
          path: 'Newsbox',
          name: 'NewsboxGlobal',
          component: NewsboxGlobal
        },
        {
          path: 'AdminLog',
          name: 'AdminLog',
          component: AdminLog
        },
        {
          path: 'StructureDataAnchor/:idModule/:aaNr/:crefoNr/:rkNr/:source/:year',
          name: 'StructureDataAnchor',
          component: StructureData
        },
        {
          path: 'StructureDataDetailed/:idModule/:aaNr/:crefoNr/:rkNr/:source/:year',
          name: 'StructureDataDetail',
          component: StructureData
        },
        {
          path: 'StructureData/:idModule',
          name: 'StructureData',
          component: StructureData
        },
        {
          path: 'search/:idModule',
          name: 'Suche',
          component: Suche
        },
        {
          path: 'ModuleTB/:idModule',
          name: 'ModuleTB',
          component: Module
        },
        {
          path: 'Module/:idModule',
          name: 'Module',
          component: Module
        },
        {
          path: 'Newsbox/:idModule',
          name: 'Newsbox',
          component: Newsbox
        },
        {
          path: 'Konfiguration/:idModule',
          name: 'ModuleConfig',
          component: ModuleConfig
        },
        {
          path: 'Konfiguration/:idModule/Suchmaske',
          name: 'SMConfigGeneral',
          props: true,
          component: TableSearchMaskColumns
        },
        {
          path: 'Konfiguration/:idModule/Trefferliste',
          name: 'TLConfigGeneral',
          props: true,
          component: TLConfig
        },
        {
          path: 'Konfiguration/:idModule/Suchmaske/:balanceName/:defUserId/:clientNr',
          name: 'SMConfig',
          component: TableSearchMaskColumns
        },
        {
          path: 'Konfiguration/:idModule/Trefferliste/:balanceName/:defUserId/:clientNr',
          name: 'TLConfig',
          component: TLConfig
        }
      ]
    },
    {
      path: '/Logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/Forward',
      name: 'Forward',
      component: Forward,
      props: true
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/ResetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/ResetPasswordExpires',
      name: 'ResetPasswordExpires',
      component: ResetPasswordExpires
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js